// extracted by css-extract-rspack-plugin
export default {"root":"root-OT4sMo","header":"header-stP4qH"};